
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/d6212764e2e22a594116bb5aaa2c701d/47a096264119cb62209e551a4bc73f5a.png" 
                alt="Baufaktura Logo" 
                className="h-10 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-primary transition-colors">
              Home
            </Link>
            <Link to="/preise" className="text-gray-700 hover:text-primary transition-colors">
              Preise
            </Link>
            <Link to="/versionsvergleich" className="text-gray-700 hover:text-primary transition-colors">
              Versionsvergleich
            </Link>
            <Link to="/shop" className="text-gray-700 hover:text-primary transition-colors">
              Shop
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Button variant="outline" size="sm">
              Demo anfordern
            </Button>
            <Button size="sm">
              Jetzt testen
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#2D4191] cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-[#E4E4DF]">
            <div className="flex flex-col space-y-4">
              <a href="#funktionen" className="text-gray-700 hover:text-[#2D4191] transition-colors cursor-pointer">
                Funktionen
              </a>
              <Link to="/versionsvergleich" className="text-gray-700 hover:text-[#2D4191] transition-colors cursor-pointer">
                Versionsvergleich
              </Link>
              <a href="#vorteile" className="text-gray-700 hover:text-[#2D4191] transition-colors cursor-pointer">
                Vorteile
              </a>
              <a href="#preise" className="text-gray-700 hover:text-[#2D4191] transition-colors cursor-pointer">
                Preise
              </a>
              <a href="#support" className="text-gray-700 hover:text-[#2D4191] transition-colors cursor-pointer">
                Support
              </a>
              <a href="#kontakt" className="text-gray-700 hover:text-[#2D4191] transition-colors cursor-pointer">
                Kontakt
              </a>
              <div className="flex flex-col space-y-2 pt-4">
                <Button variant="outline" size="sm" fullWidth>
                  Demo anfordern
                </Button>
                <Button size="sm" fullWidth>
                  Jetzt testen
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
